var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "h3",
        {
          staticClass: "mb-0 pb-2",
          class: {
            "d-flex align-item-center justify-content-between": !_vm.isDisabled,
            active: _vm.isActive
          },
          on: {
            click: function($event) {
              return _vm.toggle()
            }
          }
        },
        [
          _c("div", [_vm._t("title")], 2),
          _vm._v(" "),
          !_vm.isDisabled
            ? _c("div", { staticClass: "toggle" }, [
                _vm._v(_vm._s(_vm.isActive ? "-" : "+"))
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c("collapse-transition", [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isActive,
                expression: "isActive"
              }
            ]
          },
          [_c("div", { staticClass: "pb-2" }, [_vm._t("default")], 2)]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }